import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { sessionQuery } from "@/api/queries/session";

// Guards routes that need a signed-in Person (plan §12.1): anonymous → /join, no Person → /welcome.
export const Route = createFileRoute("/_app/_authed")({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery());
    if (session.status === "anonymous") {
      throw redirect({ to: "/join", search: { returnTo: location.href } });
    }
    if (!session.person) {
      throw redirect({ to: "/welcome", search: { step: "identity", returnTo: location.href } });
    }
    return { session };
  },
  component: () => <Outlet />,
});
